// Imports
import ___CSS_LOADER_API_NO_SOURCEMAP_IMPORT___ from "../../../../../node_modules/css-loader/dist/runtime/noSourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_NO_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `._9J7_rlTXIgop6 {
  position: relative;
  width: 321px;
  margin-bottom: var(--ds-space-200, 16px);
  border: 1px solid var(--ds-border, #091e4224);
  border-radius: var(--ds-border-radius-100, 3px);
  text-align: center;
}
._9J7_rlTXIgop6 .kJE3kyrNvrq8nO {
  margin-top: var(--ds-space-500, 40px);
  color: var(--ds-text, #172b4d);
  font-size: 24px;
  letter-spacing: -0.01em;
  line-height: 28px;
  font-weight: var(--ds-font-weight-semibold, 600);
  margin-top: var(--ds-space-250, 18px);
  margin-bottom: var(--ds-space-0, 0);
}
._9J7_rlTXIgop6 .OVZgkpKNgcrIMa {
  font-weight: var(--ds-font-weight-regular, 400);
  margin-top: var(--ds-space-100, 8px);
  color: var(--ds-text, #172b4d);
  font-size: 12px;
  line-height: 16px;
}
._9J7_rlTXIgop6 .w1wm44UhJl5AvD {
  margin-bottom: var(--ds-space-200, 16px);
}
._9J7_rlTXIgop6 .w1wm44UhJl5AvD .zunGvTbNy5q6bU {
  margin-top: 52px;
  color: var(--ds-text, #172b4d);
  font-size: 35px;
  letter-spacing: -0.01em;
  line-height: 40px;
  font-weight: var(--ds-font-weight-semibold, 600);
}
._9J7_rlTXIgop6 .w1wm44UhJl5AvD .tw0GutzSmMpFdg,
._9J7_rlTXIgop6 .w1wm44UhJl5AvD .dAzRrNGF1bM7KP {
  font-weight: var(--ds-font-weight-regular, 400);
  display: inline-block;
  margin-left: var(--ds-space-075, 5px);
  color: var(--ds-text-subtle, #44546f);
  font-size: 12px;
  line-height: 16px;
  text-align: center;
}
._9J7_rlTXIgop6 .FYQlyhLFhK9Hma {
  margin-bottom: var(--ds-space-200, 16px);
}
._9J7_rlTXIgop6 .FYQlyhLFhK9Hma .Bbk_5i19SGlsod {
  font-weight: var(--ds-font-weight-regular, 400);
  display: inline-block;
  margin-left: var(--ds-space-075, 5px);
  color: var(--ds-text-subtle, #44546f);
  font-size: 12px;
  line-height: 16px;
  text-align: center;
}
._9J7_rlTXIgop6 .QZbQDgXDSLD8lh {
  display: grid;
  height: 70px;
  padding: var(--ds-space-0, 0) var(--ds-space-200, 15px);
  border: 1px solid var(--ds-border, #091e4224);
  background: var(--ds-background-neutral, #091e420f);
  place-items: center;
}
._9J7_rlTXIgop6 .QZbQDgXDSLD8lh p {
  margin-bottom: var(--ds-space-0, 0);
}
@media only screen and (max-width: 450px) {
  ._9J7_rlTXIgop6 {
    width: 265px;
  }
}
`, ""]);
// Exports
export var planCard = `_9J7_rlTXIgop6`;
export var name = `kJE3kyrNvrq8nO`;
export var info = `OVZgkpKNgcrIMa`;
export var priceContainer = `w1wm44UhJl5AvD`;
export var price = `zunGvTbNy5q6bU`;
export var frequency = `tw0GutzSmMpFdg`;
export var pricingVaries = `dAzRrNGF1bM7KP`;
export var ctaContainer = `FYQlyhLFhK9Hma`;
export var currentPlan = `Bbk_5i19SGlsod`;
export var enterpriseFooter = `QZbQDgXDSLD8lh`;
export default ___CSS_LOADER_EXPORT___;
